import { type AuditEntry } from '@vello/api-client';
import { useVocab } from './vocab';

/**
 * D577: the words of one line of a case audit trail (safety incident, support ticket, risk case). The server sends the action
 * as a declared code, the real reason (when the action carries one) with the vocabulary that translates it, and a contact
 * reveal's party / purpose apart — each goes through the catalog; nothing is read as stored text.
 */
export function useCaseAuditText(): {
  readonly actor: (e: AuditEntry) => string;
  readonly action: (e: AuditEntry) => string;
  readonly reason: (e: AuditEntry) => string;
} {
  const { v } = useVocab();
  return {
    actor: (e) => `${e.actorId} (${v('rbac.role', e.actorRole)})`,
    action: (e) => v('audit.case_action', e.action),
    reason: (e) => {
      if (e.contact !== undefined) return `${v('audit.contact_party', e.contact.party)} · ${v('customer_360.purpose', e.contact.purpose)}`;
      if (e.reason === undefined) return '—';
      return e.reason.vocabulary !== undefined ? v(e.reason.vocabulary, e.reason.code) : v('audit.case_reason', e.reason.code);
    },
  };
}
